import { render, staticRenderFns } from "./Func50Novo.vue?vue&type=template&id=c343550e&scoped=true"
import script from "./Func50Novo.vue?vue&type=script&lang=js"
export * from "./Func50Novo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c343550e",
  null
  
)

export default component.exports